module.exports = __webpack_public_path__ + "img/catalog (11).72a6e811.jpg";